import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changeProductCardQuantities, changeProductCardQuantityPerBox, changeProductCardSelections, openEditQuantityInCartPopup } from '../../../../../redux/box-builder/box-builder.actions';
import Content from '../content';
import { productCardItemsSelector, selectedProductsAmountSelector } from '../../../../../redux/box-builder/box-builder.selectors';
const mapStateToProps = createStructuredSelector({
  selectedProductsAmount: selectedProductsAmountSelector,
  cardItems: productCardItemsSelector
});
const mapDispatchToProps = dispatch => ({
  onSelectionClick: params => {
    dispatch(changeProductCardSelections(params));
  },
  onChangeHowManyInEachBox: params => {
    dispatch(changeProductCardQuantityPerBox(params));
  },
  onQuantityPerSizeChange: params => {
    dispatch(changeProductCardQuantities(params));
  },
  onQuantityInCart: (itemId, variantIndex) => {
    dispatch(openEditQuantityInCartPopup(itemId, variantIndex));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(Content);